class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (this.detailsContainer) {
      this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    }
    
    if (this.summaryToggle) {
      this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
      this.summaryToggle.setAttribute('role', 'button');
    }
    
    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    // For search modal, only close on close button click, not on overlay or anywhere else
    const isSearchModal = this.classList.contains('header__search');
    if (isSearchModal) {
      // Don't close on any click - only the close button should close it
      return;
    }
    // For other modals, keep original behavior
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // Trigger GSAP animation for search modal if available
    const searchModal = this.querySelector('.search-modal');
    if (searchModal && typeof window.GSAPAnimations !== 'undefined') {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        window.GSAPAnimations.animateSearchModal(searchModal, true);
      }, 10);
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    // Trigger GSAP close animation for search modal if available
    const searchModal = this.querySelector('.search-modal');
    if (searchModal && typeof window.GSAPAnimations !== 'undefined') {
      const timeline = window.GSAPAnimations.animateSearchModal(searchModal, false);
      if (timeline) {
        timeline.eventCallback('onComplete', () => {
          removeTrapFocus(focusToggle ? this.summaryToggle : null);
          this.detailsContainer.removeAttribute('open');
          document.body.removeEventListener('click', this.onBodyClickEvent);
          document.body.classList.remove('overflow-hidden');
        });
        return; // Exit early, cleanup will happen in animation callback
      }
    }
    
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
